import { render } from "./CampaignFile.vue?vue&type=template&id=1a3ebb42&scoped=true"
import script from "./CampaignFile.vue?vue&type=script&lang=js"
export * from "./CampaignFile.vue?vue&type=script&lang=js"

import "./CampaignFile.vue?vue&type=style&index=0&id=1a3ebb42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3ebb42"]])

export default __exports__